// Central place to read environment variables (Vite-style).
// All public client-side config values should be prefixed with .

interface EnvConfig {
  firebaseApiKey: string;
  firebaseAuthDomain: string;
  firebaseProjectId: string;
  firebaseStorageBucket: string;
  firebaseMessagingSenderId: string;
  firebaseAppId: string;

  apiBaseUrl: string;
  openaiApiBaseUrl: string;
  openaiApiKey: string;
  openaiTextModel: string;
  openaiTextModelHighQuality: string;
  openaiVisionModel: string;
  sentryDsn: string;
}

const viteEnv = import.meta.env;

// Helper to get env var with trimming (removes whitespace)
function getEnvVar(prefixed: string | undefined, nonPrefixed: string | undefined): string {
  const value = (prefixed ?? nonPrefixed ?? '').trim();
  return value;
}

export const env: EnvConfig = {
  firebaseApiKey: getEnvVar(viteEnv.VITE_FIREBASE_API_KEY, viteEnv.FIREBASE_API_KEY),
  firebaseAuthDomain: getEnvVar(viteEnv.VITE_FIREBASE_AUTH_DOMAIN, viteEnv.FIREBASE_AUTH_DOMAIN),
  firebaseProjectId: getEnvVar(viteEnv.VITE_FIREBASE_PROJECT_ID, viteEnv.FIREBASE_PROJECT_ID),
  firebaseStorageBucket: getEnvVar(viteEnv.VITE_FIREBASE_STORAGE_BUCKET, viteEnv.FIREBASE_STORAGE_BUCKET),
  firebaseMessagingSenderId: getEnvVar(viteEnv.VITE_FIREBASE_MESSAGING_SENDER_ID, viteEnv.FIREBASE_MESSAGING_SENDER_ID),
  firebaseAppId: getEnvVar(viteEnv.VITE_FIREBASE_APP_ID, viteEnv.FIREBASE_APP_ID),

  apiBaseUrl: (() => {
    const url = getEnvVar(viteEnv.VITE_API_BASE_URL, viteEnv.API_BASE_URL);
    // In development, if URL is not set or points to wrong port, use localhost:8080
    if (import.meta.env.DEV) {
      if (!url || url === 'https://api.your-backend.dev' || url.includes(':8000')) {
        return 'http://localhost:8080';
      }
    }
    return url;
  })(),
  openaiApiBaseUrl: getEnvVar(viteEnv.VITE_OPENAI_API_BASE_URL, viteEnv.OPENAI_API_BASE_URL),
  openaiApiKey: getEnvVar(viteEnv.VITE_OPENAI_API_KEY, viteEnv.OPENAI_API_KEY),
  openaiTextModel: getEnvVar(viteEnv.VITE_OPENAI_TEXT_MODEL, viteEnv.OPENAI_TEXT_MODEL),
  openaiTextModelHighQuality: getEnvVar(
    viteEnv.VITE_OPENAI_TEXT_MODEL_HIGH_QUALITY,
    viteEnv.OPENAI_TEXT_MODEL_HIGH_QUALITY,
  ),
  openaiVisionModel: getEnvVar(viteEnv.VITE_OPENAI_VISION_MODEL, viteEnv.OPENAI_VISION_MODEL),
  sentryDsn: getEnvVar(viteEnv.VITE_SENTRY_DSN, viteEnv.SENTRY_DSN),
};

// Debug logging removed - not relevant to weekly/daily averages


